import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Component, ViewChild, Input, Output, NgModule } from '@angular/core';
import { map, take, first } from 'rxjs/operators';
import * as i1 from '@angular/common/http';
import { __rest } from 'tslib';
import { HelpVideoOverlayLibraryComponent, HelpVideoOverlayLibraryModule } from 'help-video-overlay-library';
import * as i1$1 from '@angular/forms';
import { Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { getStepDetails, updateStepStatus } from 'visa-store';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import * as i2 from '@ngrx/store';
import { select } from '@ngrx/store';
import * as i6 from 'dirty-check-store';
import { MarkDirtyFormAction } from 'dirty-check-store';
import * as errorUtils from 'error-message-utility';
import { DeleteDialogLibraryComponent } from 'delete-dialog-library';
import moment from 'moment';
import { combineLatest } from 'rxjs';
import { CustomErrorToastComponent } from 'custom-error-toast';
import * as i3 from 'base-job-description-library';
import * as i4 from 'ngx-toastr';
import * as i5 from 'step-status-update-payload-service';
import * as i7 from 'cache-country-list';
import * as i8 from 'reference-library';
import * as i9 from 'primeng/dynamicdialog';
import * as i10 from 'app-services-library';
import * as i11 from 'list-job-duties';
import * as i13 from 'base-lca-soc-code-library';
import * as i14 from '@angular/common';
import * as i15 from 'primeng/inputtext';
import * as i16 from 'primeng/calendar';
import * as i17 from 'primeng/inputswitch';
import * as i18 from 'primeng/dropdown';
import * as i19 from 'h1b-job-description';
import { H1bJobDescriptionModule } from 'h1b-job-description';
import * as i20 from 'file-upload-library';
import { FileUploadLibraryModule } from 'file-upload-library';
import * as i21 from 'primeng/button';
import * as i22 from 'primeng/divider';
import * as i23 from 'custom-questionnaire';
import { CustomQuestionnaireModule } from 'custom-questionnaire';
import { StepStatusUpdateComponentLibraryModule } from 'step-status-update-component-library';
import { PrimengLibraryModule } from 'primeng-library';
import { JobDutiesLibraryModule } from 'job-duties-library';
import { LastUpdateLibraryModule } from 'last-update-library';
import { AssigningTaskLibraryModule } from 'assigning-task-library';
import { MaximizeDialogLibraryModule } from 'maximize-dialog-library';

class JobDescriptionLcaPositionLibraryService {
    constructor(http) {
        this.http = http;
    }
    getLcaDetailsBylcaId(lcaId) {
        return this.http.get(`/dashboard/petitioner/lca/${lcaId}`).pipe(map((response) => {
            if (response.status === 200) {
                return response.data;
            }
        }));
    }
}
JobDescriptionLcaPositionLibraryService.ɵfac = function JobDescriptionLcaPositionLibraryService_Factory(t) { return new (t || JobDescriptionLcaPositionLibraryService)(i0.ɵɵinject(i1.HttpClient)); };
JobDescriptionLcaPositionLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: JobDescriptionLcaPositionLibraryService, factory: JobDescriptionLcaPositionLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JobDescriptionLcaPositionLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

const _c0 = ["jobDescriptionForm"];
function JobDescriptionLcaPositionLibraryComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22);
    i0.ɵɵelementStart(1, "h5", 23);
    i0.ɵɵtext(2, "Position Details");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function JobDescriptionLcaPositionLibraryComponent_div_7_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 41);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r9.getGlobalErrorMessages("REQUIRED"), " ");
} }
function JobDescriptionLcaPositionLibraryComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, JobDescriptionLcaPositionLibraryComponent_div_7_span_1_Template, 2, 1, "span", 40);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.jobPositionDescriptionForm.controls["jobTitle"].errors == null ? null : ctx_r1.jobPositionDescriptionForm.controls["jobTitle"].errors.required);
} }
function JobDescriptionLcaPositionLibraryComponent_div_14_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 41);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r10.getGlobalErrorMessages("REQUIRED"), " ");
} }
function JobDescriptionLcaPositionLibraryComponent_div_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, JobDescriptionLcaPositionLibraryComponent_div_14_span_1_Template, 2, 1, "span", 40);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.jobPositionDescriptionForm.controls["startDate"].errors == null ? null : ctx_r2.jobPositionDescriptionForm.controls["startDate"].errors.required);
} }
function JobDescriptionLcaPositionLibraryComponent_div_20_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 41);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r11.getGlobalErrorMessages("REQUIRED"), " ");
} }
function JobDescriptionLcaPositionLibraryComponent_div_20_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, JobDescriptionLcaPositionLibraryComponent_div_20_span_1_Template, 2, 1, "span", 40);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.jobPositionDescriptionForm.controls["endDate"].errors == null ? null : ctx_r3.jobPositionDescriptionForm.controls["endDate"].errors.required);
} }
function JobDescriptionLcaPositionLibraryComponent_div_21_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "span", 41);
    i0.ɵɵtext(2, " End date should be greater than or equal to Start Date ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function JobDescriptionLcaPositionLibraryComponent_div_30_div_5_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 41);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r13.getGlobalErrorMessages("REQUIRED"), " ");
} }
function JobDescriptionLcaPositionLibraryComponent_div_30_div_5_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 41);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r14.getGlobalErrorMessages("NUMBER_ONLY"), " ");
} }
function JobDescriptionLcaPositionLibraryComponent_div_30_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, JobDescriptionLcaPositionLibraryComponent_div_30_div_5_span_1_Template, 2, 1, "span", 40);
    i0.ɵɵtemplate(2, JobDescriptionLcaPositionLibraryComponent_div_30_div_5_span_2_Template, 2, 1, "span", 40);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r12.jobPositionDescriptionForm.get("workingHoursPerWeek").errors == null ? null : ctx_r12.jobPositionDescriptionForm.get("workingHoursPerWeek").errors.required);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r12.jobPositionDescriptionForm.get("workingHoursPerWeek").errors == null ? null : ctx_r12.jobPositionDescriptionForm.get("workingHoursPerWeek").errors.pattern);
} }
function JobDescriptionLcaPositionLibraryComponent_div_30_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 36);
    i0.ɵɵelementStart(1, "div", 3);
    i0.ɵɵelementStart(2, "label", 42);
    i0.ɵɵtext(3, " Working Hours per week ");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "input", 43);
    i0.ɵɵtemplate(5, JobDescriptionLcaPositionLibraryComponent_div_30_div_5_Template, 3, 2, "div", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("readonly", ctx_r5.disabledControls);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.jobPositionDescriptionForm.get("workingHoursPerWeek").touched && ctx_r5.jobPositionDescriptionForm.get("workingHoursPerWeek").invalid);
} }
function JobDescriptionLcaPositionLibraryComponent_div_41_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 41);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r15.getGlobalErrorMessages("REQUIRED"), " ");
} }
function JobDescriptionLcaPositionLibraryComponent_div_41_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 41);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r16.getGlobalErrorMessages("NUMBER_ONLY"), " ");
} }
function JobDescriptionLcaPositionLibraryComponent_div_41_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, JobDescriptionLcaPositionLibraryComponent_div_41_span_1_Template, 2, 1, "span", 40);
    i0.ɵɵtemplate(2, JobDescriptionLcaPositionLibraryComponent_div_41_span_2_Template, 2, 1, "span", 40);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r6.jobPositionDescriptionForm.controls["wagesFrom"].errors == null ? null : ctx_r6.jobPositionDescriptionForm.controls["wagesFrom"].errors.required);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r6.jobPositionDescriptionForm.controls["wagesFrom"].errors == null ? null : ctx_r6.jobPositionDescriptionForm.controls["wagesFrom"].errors.pattern);
} }
function JobDescriptionLcaPositionLibraryComponent_div_46_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 41);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r17.getGlobalErrorMessages("REQUIRED"), " ");
} }
function JobDescriptionLcaPositionLibraryComponent_div_46_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, JobDescriptionLcaPositionLibraryComponent_div_46_span_1_Template, 2, 1, "span", 40);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r7.jobPositionDescriptionForm.controls["wageTypeCode"].errors == null ? null : ctx_r7.jobPositionDescriptionForm.controls["wageTypeCode"].errors.required);
} }
function JobDescriptionLcaPositionLibraryComponent_lib_custom_questionnaire_60_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "lib-custom-questionnaire", 44);
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵproperty("stepId", ctx_r8.primaryData.stepId)("taskId", ctx_r8.primaryData.taskId)("viewQuestions", false)("showSaveBtn", false)("loadedIn", ctx_r8.stepDetails.stepName)("isSection", false);
} }
const deleteDialogConfigurations = {
    width: '30%',
    closeOnEscape: false,
    closable: false,
    showHeader: false,
    contentStyle: { 'z-index': '1001' }
};
class JobDescriptionLcaPositionLibraryComponent {
    constructor(jobDescriptionBuilder, store, apiService, toastr, stepStatusUpdatePayloadCostruction, guard, cacheCountyService, referenceLibraryService, changeDetector, dialogService, customValidator, appServicesLibraryService, listJobDutiesService, jobDescriptionLcaPositionLibraryService, apiServiceSOC) {
        this.jobDescriptionBuilder = jobDescriptionBuilder;
        this.store = store;
        this.apiService = apiService;
        this.toastr = toastr;
        this.stepStatusUpdatePayloadCostruction = stepStatusUpdatePayloadCostruction;
        this.guard = guard;
        this.cacheCountyService = cacheCountyService;
        this.referenceLibraryService = referenceLibraryService;
        this.changeDetector = changeDetector;
        this.dialogService = dialogService;
        this.customValidator = customValidator;
        this.appServicesLibraryService = appServicesLibraryService;
        this.listJobDutiesService = listJobDutiesService;
        this.jobDescriptionLcaPositionLibraryService = jobDescriptionLcaPositionLibraryService;
        this.apiServiceSOC = apiServiceSOC;
        this.jobDescriptionSubmitted = new EventEmitter();
        this.observableSubscription$ = new Subject();
        this.userType = sessionStorage.getItem("userTypeRole");
    }
    ngOnInit() {
        if (sessionStorage.getItem('isSimplify') && sessionStorage.getItem('isSimplify') == 'CWF') {
            this.isSimplify = true;
        }
        else {
            this.isSimplify = false;
        }
        this.isForeignCompany = this.isForeignCompany;
        this.inputData = this.primaryData;
        this.jobPositionDescriptionForm = this.jobDescriptionBuilder.group({
            id: [null],
            jobTitle: [null, Validators.required],
            duties: this.jobDescriptionBuilder.array([]),
            wagesFrom: [null, [Validators.required, Validators.pattern(/^[1-9]\d*(\.\d+)?$/)]],
            wageTypeCode: [null, Validators.required],
            wagesPerYear: ['', [Validators.required, Validators.pattern(/^[1-9]\d*(\.\d+)?$/)]],
            wageTypeName: [null],
            thisFulltime: [false],
            workingHoursPerWeek: [null],
            startDate: [null, [Validators.required]],
            endDate: [null, [Validators.required]],
            workLocationId: [null],
            // caseId: [],
            // socCode1: [null],
            // socCode2: [null],
            // thisPastJob: [false],
            offerSignedByName: [null],
            educationRequired: [null],
            dotCode: [null],
            experienceRequired: [null],
            fieldOfStudy: [null],
            technicalSkills: [null],
            clientPhoneCountryCode: [this.isForeignCompany ? null : 'USA'],
            jobDutyForceDelete: false,
            jobRole: [null],
            otherJobPosition: [null],
            selectedCategory: [null],
            selectedRaiobtn: [0],
            selectedEducationId: [null]
        }, {
            validator: this.customValidator.dateLessThan('startDate', 'endDate'),
        });
        this.getWageUnitType();
        this.updateFormControls();
        if (this.isForeignCompany) {
            this.cacheCountyService.getCountryWithoutUSA().subscribe(data => {
                if (data.length > 0) {
                    this.countryList = data;
                }
            });
        }
        else {
            this.getCountries();
        }
        if (this.isFromWizard) {
            this.getJobDescription();
            this.fileUploadConfigurations = Object.assign({}, {
                disableControls: this.disabledControls,
                isDocumentTypeRequired: true,
                isDocumentUploadRequired: true,
                isViewEnabled: true,
                isDownloadEnabled: true,
                isDeleteEnabled: true,
                getApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/category/${(this.inputData.visatype === 'H1-B' || this.inputData.layoutCode === 'H1_B_POSITION_DETAIL') ? 'POSOFFRLTR' : 'POSOFFRLTR'}/`,
                postApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/category/${(this.inputData.visatype === 'H1-B' || this.inputData.layoutCode === 'H1_B_POSITION_DETAIL') ? 'POSOFFRLTR' : 'POSOFFRLTR'}/fileCategory/`,
                deleteApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/`,
                documentTypeDropdownCode: (this.inputData.visatype === 'H1-B' || this.inputData.layoutCode === 'H1_B_POSITION_DETAIL') ? 'POSOFFRLTR' : 'POSOFFRLTR',
                getDocTypeApiUrl: '/referenceLibrary/POSOFFRLTR'
            });
            this.apiServiceSOC.getLcaSOCCodeSelection(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId).subscribe((response) => {
                var _a;
                if (response) {
                    if (this.isFromWizard) {
                        this.lcaCodeId = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.lcaCodeId;
                        if (this.lcaCodeId) {
                            // get the lca details.
                            this.jobDescriptionLcaPositionLibraryService.getLcaDetailsBylcaId(this.lcaCodeId).
                                subscribe((data) => {
                                var _a, _b, _c, _d, _e, _f;
                                this.jobPositionDescriptionForm.patchValue({
                                    jobTitle: (_a = data === null || data === void 0 ? void 0 : data.lcaApplication) === null || _a === void 0 ? void 0 : _a.jobTitle,
                                    startDate: new Date(moment((_b = data === null || data === void 0 ? void 0 : data.lcaApplication) === null || _b === void 0 ? void 0 : _b.employmentStartDate).format('MM/DD/YYYY')),
                                    endDate: new Date(moment((_c = data === null || data === void 0 ? void 0 : data.lcaApplication) === null || _c === void 0 ? void 0 : _c.employmentEndDate).format('MM/DD/YYYY')),
                                    // workingHoursPerWeek: data?.placeList[0]?.wageRangeFrom,
                                    wagesFrom: (_d = data === null || data === void 0 ? void 0 : data.placeList[0]) === null || _d === void 0 ? void 0 : _d.wageRangeFrom,
                                    wageTypeCode: (_e = data === null || data === void 0 ? void 0 : data.placeList[0]) === null || _e === void 0 ? void 0 : _e.wageRangeTypeCode,
                                    wagesPerYear: (_f = data === null || data === void 0 ? void 0 : data.placeList[0]) === null || _f === void 0 ? void 0 : _f.prvlWageRate
                                });
                            });
                        }
                        else {
                            CustomErrorToastComponent.showErrorToast(this.toastr, 'Details are not auto populated due to missing lca');
                        }
                    }
                }
            });
        }
        // Get Specific step details by passing step code
        this.store.pipe(select(getStepDetails, { id: this.inputData.stepId }))
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((data) => {
            this.getJobDescription();
            this.typeOfButton = data.isPetitionerAction === 1 || data.isAttorneyAction === 1 ? 'MARK_COMPLETE' : 'MARK_SUBMIT';
            this.stepDetails = data;
            this.fileUploadConfigurations = Object.assign({}, {
                disableControls: this.disabledControls,
                isDocumentTypeRequired: true,
                isDocumentUploadRequired: true,
                isViewEnabled: true,
                isDownloadEnabled: true,
                isDeleteEnabled: true,
                getApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/category/${(this.inputData.visatype === 'H1-B' || this.inputData.layoutCode === 'H1_B_POSITION_DETAIL') ? 'POSOFFRLTR' : 'POSOFFRLTR'}/`,
                postApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/category/${(this.inputData.visatype === 'H1-B' || this.inputData.layoutCode === 'H1_B_POSITION_DETAIL') ? 'POSOFFRLTR' : 'POSOFFRLTR'}/fileCategory/`,
                deleteApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/`,
                documentTypeDropdownCode: (this.inputData.visatype === 'H1-B' || this.inputData.layoutCode === 'H1_B_POSITION_DETAIL') ? 'POSOFFRLTR' : 'POSOFFRLTR',
                getDocTypeApiUrl: '/referenceLibrary/POSOFFRLTR'
                // getApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/category/${this.inputData.visatype === 'H1-B' ? 'POSOFFRLTR' : 'PETDOCTYP'}/`,
                // postApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/category/${this.inputData.visatype === 'H1-B' ? 'POSOFFRLTR' : 'PETDOCTYP'}/fileCategory/`,
                // deleteApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/`,
                // documentTypeDropdownCode: this.inputData.visatype === 'H1-B' ? 'POSOFFRLTR' : 'OFFLTR'
            });
            this.toggleControlsStatus();
        });
    }
    // Toggle controls status based on step status
    toggleControlsStatus() {
        this.disabledControls = this.appServicesLibraryService.formToBeDisabled(this.stepDetails.stepStatusDetails.stepStatusCode);
        // console.log('toggleControlsStatus ::', this.disabledControls);
        this.fileUploadConfigurations = Object.assign({}, {
            disableControls: this.disabledControls,
            isDocumentTypeRequired: true,
            isDocumentUploadRequired: true,
            isViewEnabled: true,
            isDownloadEnabled: true,
            isDeleteEnabled: true,
            getApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/category/${(this.inputData.visatype === 'H1-B' || this.inputData.layoutCode === 'H1_B_POSITION_DETAIL') ? 'POSOFFRLTR' : 'POSOFFRLTR'}/`,
            postApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/category/${(this.inputData.visatype === 'H1-B' || this.inputData.layoutCode === 'H1_B_POSITION_DETAIL') ? 'POSOFFRLTR' : 'POSOFFRLTR'}/fileCategory/`,
            deleteApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/`,
            documentTypeDropdownCode: (this.inputData.visatype === 'H1-B' || this.inputData.layoutCode === 'H1_B_POSITION_DETAIL') ? 'POSOFFRLTR' : 'POSOFFRLTR',
            getDocTypeApiUrl: '/referenceLibrary/POSOFFRLTR'
            // getApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/category/${this.inputData.visatype === 'H1-B' ? 'POSOFFRLTR' : 'PETDOCTYP'}/`,
            // postApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/category/${this.inputData.visatype === 'H1-B' ? 'POSOFFRLTR' : 'PETDOCTYP'}/fileCategory/`,
            // deleteApiUrl: `/${this.inputData.visatype}/${this.inputData.caseType}/${this.inputData.caseId}/document/`,
            // documentTypeDropdownCode: this.inputData.visatype === 'H1-B' ? 'POSOFFRLTR' : 'OFFLTR'
        });
    }
    getGlobalErrorMessages(error) {
        return errorUtils.errorMessages.get(error);
    }
    handleDeleteAllDuties() {
        if (this.inputData.visatype === 'H1-B' || this.inputData.layoutCode === 'H1_B_POSITION_DETAIL') {
            // api call to check whether ios is mapped or not
            const deleteDialogRef = this.dialogService.open(DeleteDialogLibraryComponent, deleteDialogConfigurations);
            deleteDialogRef.onClose.pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
                if (response) {
                    // if duty has id and user tries to delete it
                    this.apiService.getIOSMapping(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, this.jobPositionDescriptionForm.value.id, 0)
                        .pipe(takeUntil(this.observableSubscription$))
                        .subscribe((IOSMappingResponse) => {
                        if (IOSMappingResponse && IOSMappingResponse.data && IOSMappingResponse.data['isAnyDependency']) {
                            this.handleReconfirmDuty();
                        }
                        else {
                            this.jobPositionDescriptionForm.controls['duties'].clear();
                            this.store.dispatch(new MarkDirtyFormAction({
                                dirty: true
                            }));
                        }
                    });
                }
            });
        }
        else {
            this.jobPositionDescriptionForm.controls['duties'].clear();
            this.store.dispatch(new MarkDirtyFormAction({
                dirty: true
            }));
        }
    }
    getWageUnitType() {
        this.referenceLibraryService.getReferenceData('PAYTYP')
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            this.wageUnitType = response;
        });
    }
    onWageUnitChange(event) {
        switch (event.value) {
            case 'HOUR':
                this.jobPositionDescriptionForm.controls['wagesPerYear'].setValue(2080 * this.jobPositionDescriptionForm.controls['wagesFrom'].value);
                break;
            case 'WEEK':
                this.jobPositionDescriptionForm.controls['wagesPerYear'].setValue(52 * this.jobPositionDescriptionForm.controls['wagesFrom'].value);
                break;
            case 'BIWEEK':
                this.jobPositionDescriptionForm.controls['wagesPerYear'].setValue(26 * this.jobPositionDescriptionForm.controls['wagesFrom'].value);
                break;
            case 'MONTH':
                this.jobPositionDescriptionForm.controls['wagesPerYear'].setValue(12 * this.jobPositionDescriptionForm.controls['wagesFrom'].value);
                break;
            case 'YEAR':
                this.jobPositionDescriptionForm.controls['wagesPerYear'].setValue(this.jobPositionDescriptionForm.controls['wagesFrom'].value);
                break;
        }
    }
    updateFormControls() {
        this.jobPositionDescriptionForm.get('thisFulltime').valueChanges.pipe(takeUntil(this.observableSubscription$)).subscribe((value) => {
            if (value) {
                this.jobPositionDescriptionForm.get('workingHoursPerWeek').clearValidators();
            }
            else {
                this.jobPositionDescriptionForm.get('workingHoursPerWeek').setValidators(Validators.required);
            }
            this.jobPositionDescriptionForm.get('workingHoursPerWeek').reset();
            this.jobPositionDescriptionForm.get('workingHoursPerWeek').updateValueAndValidity();
        });
    }
    getJobDescription() {
        this.apiService.getJobDescription(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, this.isForeignCompany)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            var _a, _b;
            if (response.status === 200) {
                this.listJobDutiesService.setJobDescription$(response);
                this.loadFormValues(response.data);
                this.inputData.jsonInput = { jobCategory: (_a = response.data) === null || _a === void 0 ? void 0 : _a.jobCategory, jobRole: (_b = response.data) === null || _b === void 0 ? void 0 : _b.jobRole };
                // this.apiService.getJobRoles(this.inputData.companyId).pipe(takeUntil(this.observableSubscription$))
                //   .subscribe((responseJobRoles: ImagilityBaseResponse) => {
                //     if (responseJobRoles && responseJobRoles.data && responseJobRoles.data.length > 0 &&
                //       responseJobRoles.data.find(x => x.jobTitle === response.data['jobRole'])) {
                //       // predefined job role is selected do nothing
                //       response.data['otherJobPosition'] = '';
                //     }
                //     else {
                //       // Other option is selected & set the other job position manually
                //       response.data['otherJobPosition'] = response.data['jobRole'];
                //       response.data['jobRole'] = 'Other';
                //     }
                //     this.loadFormValues(response.data);
                //   });
            }
            else {
                // is there is no position details
                this.jobPositionDescriptionForm.reset();
                this.jobPositionDescriptionForm.patchValue({
                    selectedRaiobtn: 0,
                    jobRole: null
                });
                this.jobPositionDescriptionForm.markAsPristine();
                this.jobPositionDescriptionForm.markAsUntouched();
                this.fileUploadConfigurations = Object.assign({}, this.fileUploadConfigurations);
            }
        });
    }
    // Load job Desc form with values
    loadFormValues(response) {
        response = Object.assign(Object.assign({}, response), { startDate: response.startDate ? new Date(moment(response.startDate).format('MM/DD/YYYY')) : null, endDate: response.endDate ? new Date(moment(response.endDate).format('MM/DD/YYYY')) : null, duties: response.duties ? response.duties : [] });
        this.jobPositionDescriptionForm.reset(Object.assign(Object.assign({}, response), { selectedRaiobtn: 0, jobRole: null }));
        this.loadDuties(response.duties);
    }
    loadDuties(list) {
        this.jobPositionDescriptionForm.controls['duties'].clear();
        list.forEach(element => {
            this.jobPositionDescriptionForm.controls['duties'].push(this.buildDutyList(element));
        });
    }
    buildDutyList(item) {
        const subJobDuty = [];
        if (item.subduty && item.subduty.length > 0) {
            item.subduty.forEach(element => {
                subJobDuty.push(this.buildSubDutyList(element));
            });
        }
        else if (item.subJobDuty && item.subJobDuty.length > 0) {
            item.subJobDuty.forEach(element => {
                subJobDuty.push(this.buildSubDutyList(element));
            });
        }
        return this.jobDescriptionBuilder.group({
            id: item.id,
            name: item.duty || item.name,
            subJobDuty: this.jobDescriptionBuilder.array(subJobDuty)
        });
    }
    buildSubDutyList(item) {
        return this.jobDescriptionBuilder.group({
            id: item.id,
            name: item.duty || item.name
        });
    }
    handleOnsaveJobRoleOrPopulateDuties(input) {
        const overlppingReconfirmDialogRef = this.dialogService.open(DeleteDialogLibraryComponent, Object.assign(Object.assign({}, deleteDialogConfigurations), { data: {
                deleteMessage: 'Do you wish to populate duties & sub duties? This will override any existing duties'
            } }));
        overlppingReconfirmDialogRef.onClose
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            if (response) {
                if (this.jobPositionDescriptionForm.value && this.jobPositionDescriptionForm.value.id) {
                    this.apiService.getIOSMapping(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, this.jobPositionDescriptionForm.value.id, 0)
                        .pipe(take(1))
                        .subscribe((IOSMappingResponse) => {
                        if (IOSMappingResponse && IOSMappingResponse.data && IOSMappingResponse.data['isAnyDependency']) {
                            const deleteReconfirmDialogRef = this.dialogService.open(DeleteDialogLibraryComponent, Object.assign(Object.assign({}, deleteDialogConfigurations), { data: {
                                    deleteMessage: 'Job duties cannot be populated as Itinerary of Services mapping exists with the job duties. Do you want continue with the deletion of Itinerary of Services mapping?'
                                } }));
                            deleteReconfirmDialogRef.onClose
                                .pipe(takeUntil(this.observableSubscription$))
                                .subscribe((deleteReconfirmResponse) => {
                                if (deleteReconfirmResponse) {
                                    this.jobPositionDescriptionForm.controls['jobDutyForceDelete'].setValue(true);
                                    this.populateJobDuties(input);
                                }
                            });
                        }
                        else {
                            this.populateJobDuties(input);
                        }
                    });
                }
                else {
                    // if there is no position id exists. no need to check ios mapping exists
                    this.populateJobDuties(input);
                }
            }
        });
    }
    populateJobDuties(input) {
        this.jobPositionDescriptionForm.controls['duties'].clear();
        this.store.dispatch(new MarkDirtyFormAction({
            dirty: true
        }));
        this.apiService.getJobRolesDuties(this.inputData.companyId, input.selectedJobPositionId)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            if (response && response.jobDuty && response.jobDuty.length > 0) {
                response.jobDuty.forEach(element => {
                    element['id'] = null;
                    if (element.subduty && element.subduty.length > 0) {
                        element.subduty.forEach(subJobDuty => {
                            subJobDuty['id'] = null;
                        });
                    }
                    this.jobPositionDescriptionForm.controls['duties'].push(this.buildDutyList(element));
                });
            }
        });
    }
    handleAddUpdateDuty({ type, data, dutyIndex }) {
        if (type === 'ADD') {
            // If type is ADD then append the job duties to exisiting one
            this.jobPositionDescriptionForm.controls['duties'].push(this.buildDutyList(data));
            this.store.dispatch(new MarkDirtyFormAction({
                dirty: true
            }));
        }
        if (type === 'UPDATE') {
            // If type is UPDATE then update the job duties
            this.jobPositionDescriptionForm.controls['duties'].setControl(dutyIndex, this.buildDutyList(data));
            this.store.dispatch(new MarkDirtyFormAction({
                dirty: true
            }));
        }
    }
    getCountries() {
        this.cacheCountyService.getCountry().pipe(takeUntil(this.observableSubscription$)).subscribe();
        this.cacheCountyService.getCachedCountryList().pipe(takeUntil(this.observableSubscription$)).subscribe(data => {
            if (data.listCountries.length > 0) {
                this.countryList = data.listCountries;
            }
        });
    }
    postJobDescription() {
        const intermediateObj = Object.assign({}, this.jobPositionDescriptionForm.value);
        // intermediateObj.address.forEach((element: any) => {
        //   delete element['stateList'];
        // });
        const _a = Object.assign(Object.assign({}, intermediateObj), { startDate: this.jobPositionDescriptionForm.value.startDate ? moment(this.jobPositionDescriptionForm.value.startDate).format('YYYY-MM-DD') : null, endDate: this.jobPositionDescriptionForm.value.endDate ? moment(this.jobPositionDescriptionForm.value.endDate).format('YYYY-MM-DD') : null, thisPastJob: false, selectedRaiobtn: intermediateObj.selectedRaiobtn, jobRole: intermediateObj.jobRole && intermediateObj.jobRole === 'Other' ? intermediateObj.otherJobPosition : intermediateObj.jobRole }), { selectedRaiobtn } = _a, payload = __rest(_a, ["selectedRaiobtn"]);
        const APIs = [
            this.apiService.postPositionJobDescription(payload, this.inputData.visatype, this.inputData.caseType, this.inputData.caseId)
        ];
        if (selectedRaiobtn === 1) {
            const selectJobRole = JSON.parse(sessionStorage.getItem('selectedJobRole'));
            const jobDuty = this.jobPositionDescriptionForm.value.duties ?
                this.jobPositionDescriptionForm.value.duties.map(x => {
                    return {
                        dutyId: x.id ? x.id : 0,
                        duty: x.name,
                        subduty: x.subJobDuty && x.subJobDuty.length > 0 ?
                            x.subJobDuty.map(y => {
                                return {
                                    dutyId: y.id ? y.id : 0,
                                    duty: y.name,
                                };
                            }) : []
                    };
                }) : [];
            const jobRole = {
                id: selectJobRole.id,
                jobDuty,
                jobRoleName: selectJobRole.jobTitle === 'Other' ? this.jobPositionDescriptionForm.value.otherJobPosition : selectJobRole.jobTitle,
                requestFlag: 'updatemasterdata'
            };
            APIs.push(this.apiService.saveJobRole(this.inputData.companyId, this.jobPositionDescriptionForm.value.selectedCategory.id, jobRole));
        }
        combineLatest(APIs)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            // this.saveMasterDataDuty();
            if (response[0] && response[0].status === 200) {
                this.toastr.success(response[0].message, 'Success');
                this.jobDescriptionSubmitted.emit(response[0].data.jobTitle);
                if (this.stepDetails.stepStatusDetails.stepStatusCode === 'NEW') {
                    this.updateStepStatus('INPROGRESS');
                }
                else {
                    this.getJobDescription();
                }
            }
            if (selectedRaiobtn === 1 && response[1] && response[1].status === 200) {
                this.toastr.success(response[1]['message'], 'Success');
            }
        });
    }
    updateStepStatus(status) {
        this.store.dispatch(updateStepStatus({
            payload: this.stepStatusUpdatePayloadCostruction.payloadConstruction(this.stepDetails, status),
            subTaskId: this.stepDetails.taskId,
            visaType: this.inputData.caseType === 'I130' ?
                this.inputData.caseType : this.inputData.visatype,
            stepId: this.inputData.stepId
        }));
    }
    handleDutyDelete(input) {
        if (this.inputData.visatype === 'H1-B' || this.inputData.layoutCode === 'H1_B_POSITION_DETAIL') {
            // api call to check whether ios is mapped or not
            const deleteDialogRef = this.dialogService.open(DeleteDialogLibraryComponent, deleteDialogConfigurations);
            deleteDialogRef.onClose.pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
                if (response) {
                    if (input.duty['id']) {
                        // if duty has id and user tries to delete it
                        this.apiService.getIOSMapping(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, this.jobPositionDescriptionForm.value.id, this.jobPositionDescriptionForm.value.duties[input.dutyIndex].id)
                            .pipe(takeUntil(this.observableSubscription$))
                            .subscribe((IOSMappingResponse) => {
                            if (IOSMappingResponse && IOSMappingResponse.data && IOSMappingResponse.data['isAnyDependency']) {
                                this.handleReconfirmDuty(input.dutyIndex);
                            }
                            else {
                                this.jobPositionDescriptionForm.controls['duties'].removeAt(input.dutyIndex);
                                this.store.dispatch(new MarkDirtyFormAction({
                                    dirty: true
                                }));
                            }
                        });
                    }
                    else {
                        // direct delete after confirmation without IOS mapping check
                        this.jobPositionDescriptionForm.controls['duties'].removeAt(input.dutyIndex);
                        this.store.dispatch(new MarkDirtyFormAction({
                            dirty: true
                        }));
                    }
                }
            });
        }
        else {
            this.jobPositionDescriptionForm.controls['duties'].removeAt(input.dutyIndex);
            this.store.dispatch(new MarkDirtyFormAction({
                dirty: true
            }));
        }
    }
    handleSubDutyDelete(input) {
        if (this.inputData.visatype === 'H1-B' || this.inputData.layoutCode === 'H1_B_POSITION_DETAIL') {
            // api call to check whether ios is mapped or not
            const deleteDialogRef = this.dialogService.open(DeleteDialogLibraryComponent, deleteDialogConfigurations);
            deleteDialogRef.onClose.pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
                if (response) {
                    this.jobPositionDescriptionForm.controls['duties']
                        .controls[input.dutyIndex]
                        .controls['subJobDuty'].removeAt(input.subJobDutyIndex);
                    this.store.dispatch(new MarkDirtyFormAction({
                        dirty: true
                    }));
                }
            });
        }
        else {
            this.jobPositionDescriptionForm.controls['duties']
                .controls[input.dutyIndex]
                .controls['subJobDuty'].removeAt(input.subJobDutyIndex);
            this.store.dispatch(new MarkDirtyFormAction({
                dirty: true
            }));
        }
    }
    handleReconfirmDuty(dutyIndex = null) {
        const deleteReconfirmDialogRef = this.dialogService.open(DeleteDialogLibraryComponent, Object.assign(Object.assign({}, deleteDialogConfigurations), { data: {
                deleteMessage: 'Job duties cannot be deleted as Itinerary of Services mapping exists with the job duties. Do you want continue with the deletion of Itinerary of Services mapping?'
            } }));
        deleteReconfirmDialogRef.onClose
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            if (response) {
                this.jobPositionDescriptionForm.controls['jobDutyForceDelete'].setValue(true);
                if (dutyIndex) {
                    this.jobPositionDescriptionForm.controls['duties'].removeAt(dutyIndex);
                }
                else {
                    this.jobPositionDescriptionForm.controls['duties'].clear();
                }
                this.store.dispatch(new MarkDirtyFormAction({
                    dirty: true
                }));
            }
        });
    }
    ngAfterViewInit() {
        this.jobPositionDescriptionForm = this.jobPositionDescriptionForm;
        this.helpVideoComponent.setValues('right', 'Designing a Job Description', 'Designing A Job Description');
        // super.afterViewInit();
    }
    handleClose() {
        this.guard.canDeactivate().pipe(first()).subscribe((response) => {
            if (response) {
                // this.onDialogClose.emit();
            }
            else {
                return false;
            }
        });
    }
    ngOnDestroy() {
        // super.onDestroy();
    }
}
JobDescriptionLcaPositionLibraryComponent.ɵfac = function JobDescriptionLcaPositionLibraryComponent_Factory(t) { return new (t || JobDescriptionLcaPositionLibraryComponent)(i0.ɵɵdirectiveInject(i1$1.FormBuilder), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i3.APIJobDescription), i0.ɵɵdirectiveInject(i4.ToastrService), i0.ɵɵdirectiveInject(i5.StepStatusUpdatePayloadService), i0.ɵɵdirectiveInject(i6.DirtyFormGuard), i0.ɵɵdirectiveInject(i7.CacheCountryListService), i0.ɵɵdirectiveInject(i8.ReferenceLibraryService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i9.DialogService), i0.ɵɵdirectiveInject(i3.DateValidators), i0.ɵɵdirectiveInject(i10.AppServicesLibraryService), i0.ɵɵdirectiveInject(i11.ListJobDutiesService), i0.ɵɵdirectiveInject(JobDescriptionLcaPositionLibraryService), i0.ɵɵdirectiveInject(i13.APILCASOCCode)); };
JobDescriptionLcaPositionLibraryComponent.ɵcmp = i0.ɵɵdefineComponent({ type: JobDescriptionLcaPositionLibraryComponent, selectors: [["job-description-lca-position-library"]], viewQuery: function JobDescriptionLcaPositionLibraryComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(HelpVideoOverlayLibraryComponent, 1);
        i0.ɵɵviewQuery(_c0, 3);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.helpVideoComponent = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.jobPositionDescriptionForm = _t.first);
    } }, inputs: { isForeignCompany: "isForeignCompany", primaryData: "primaryData", deleteAllDutie: "deleteAllDutie", addUpdateDuty: "addUpdateDuty", deleteDuty: "deleteDuty", deleteSubDuty: "deleteSubDuty", parentForm: "parentForm", isFromWizard: "isFromWizard" }, outputs: { jobDescriptionSubmitted: "jobDescriptionSubmitted" }, decls: 66, vars: 30, consts: [[3, "formGroup", "ngSubmit"], ["class", "row col-md-12", 4, "ngIf"], [1, "row", "col-md-12", "pl-0", "mb-3"], [1, "col-md-4", "form-group", "input-disabled"], [1, "label-cls", "positionTitle", "required"], ["formControlName", "jobTitle", "type", "text", "pInputText", "", "placeholder", "Enter", 1, "im-input", "mw-100", 3, "readonly"], [4, "ngIf"], ["id", "cusomJobdate", 1, "row", "col-md-12", "mb-3", "p-0"], [1, "col-md-4", "form-group"], [1, "label-cls", "row", "required"], ["id", "startDate", "yearRange", "1900:2100", "appendTo", "body", "type", "text", "yearNavigator", "true", "monthNavigator", "true", "formControlName", "startDate", "showIcon", "true", "showButtonBar", "true", "inputId", "icon", "dateFormat", "mm/dd/yy", "placeholder", "MM/DD/YY", "name", "startDate", 1, "mw-100", 3, "disabled", "showIcon"], [1, "col-md-5", "form-group", "input-disabled"], [1, "row", "label-cls", "required"], ["yearRange", "1900:2100", "id", "endDate", "appendTo", "body", "type", "text", "formControlName", "endDate", "yearNavigator", "true", "monthNavigator", "true", "showIcon", "true", "showButtonBar", "true", "inputId", "icon", "dateFormat", "mm/dd/yy", "placeholder", "MM/DD/YY", "name", "endDate", 1, "mw-100", 3, "disabled", "showIcon"], [1, "row", "col-md-12", "p-0"], [1, "col-md-12", "p-0", "form-group"], [1, "row", "col-md-6"], ["name", "question", 1, "col-md-11", "pl-0", "bold-label"], [1, "label-cls"], [1, "col-md-1"], ["id", "thisFulltime", "value", "thisFulltime", "formControlName", "thisFulltime", 1, "swtBtn", 3, "disabled"], ["class", "row", 4, "ngIf"], [1, "row", "col-md-12"], [1, "sub-title"], [1, "row", "col-md-12", "p-0", "mb-3"], [1, "label-cls", "required"], [1, "p-input-icon-left", "mask-input", "mw-100"], [1, "pi", "pi-dollar"], ["id", "wagesFrom", "formControlName", "wagesFrom", "type", "text", "pInputText", "", "placeholder", "", 1, "im-input", "mask-in", "mw-100", 3, "readonly"], [1, "col-md-4", "processing-dropdown"], ["id", "wageTypeCode", "appendTo", "body", "formControlName", "wageTypeCode", "optionLabel", "name", "optionValue", "code", "placeholder", "select", 3, "options", "filter", "disabled", "onChange"], ["id", "wagesPerYear", "formControlName", "wagesPerYear", "type", "text", "pInputText", "", "placeholder", "", 1, "im-input", "mask-in", "mw-100", 3, "readonly"], [2, "width", "100%", 3, "parentForm", "disabledControls", "beneficiaryId", "isWizard", "petitionId"], [1, "sub-title", "uploadLetter"], [2, "width", "100%", 3, "fileUploadConfigurations"], [3, "stepId", "taskId", "viewQuestions", "showSaveBtn", "loadedIn", "isSection", 4, "ngIf"], [1, "row"], [1, "col-md-9"], [1, "col-md-3", "alignRight"], ["pButton", "", "type", "submit", "title", "Save", 3, "label", "ngClass", "disabled"], ["class", "invalid-message", 4, "ngIf"], [1, "invalid-message"], [1, "label-cls", "workingHr", "required"], ["type", "text", "id", "workingHoursPerWeek", "formControlName", "workingHoursPerWeek", "placeholder", "Enter", "pattern", "\\d{1,5}", "pInputText", "", 1, "im-input", "mw-100", 3, "readonly"], [3, "stepId", "taskId", "viewQuestions", "showSaveBtn", "loadedIn", "isSection"]], template: function JobDescriptionLcaPositionLibraryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "form", 0);
        i0.ɵɵlistener("ngSubmit", function JobDescriptionLcaPositionLibraryComponent_Template_form_ngSubmit_0_listener() { return ctx.postJobDescription(); });
        i0.ɵɵtemplate(1, JobDescriptionLcaPositionLibraryComponent_div_1_Template, 3, 0, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵelementStart(4, "label", 4);
        i0.ɵɵtext(5, " Position Title ");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(6, "input", 5);
        i0.ɵɵtemplate(7, JobDescriptionLcaPositionLibraryComponent_div_7_Template, 2, 1, "div", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "div", 7);
        i0.ɵɵelementStart(9, "div", 8);
        i0.ɵɵelementStart(10, "label", 9);
        i0.ɵɵtext(11, " Start Date ");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(12, "br");
        i0.ɵɵelement(13, "p-calendar", 10);
        i0.ɵɵtemplate(14, JobDescriptionLcaPositionLibraryComponent_div_14_Template, 2, 1, "div", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(15, "div", 11);
        i0.ɵɵelementStart(16, "label", 12);
        i0.ɵɵtext(17, " End Date ");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(18, "br");
        i0.ɵɵelement(19, "p-calendar", 13);
        i0.ɵɵtemplate(20, JobDescriptionLcaPositionLibraryComponent_div_20_Template, 2, 1, "div", 6);
        i0.ɵɵtemplate(21, JobDescriptionLcaPositionLibraryComponent_div_21_Template, 3, 0, "div", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(22, "div", 14);
        i0.ɵɵelementStart(23, "div", 15);
        i0.ɵɵelementStart(24, "div", 16);
        i0.ɵɵelementStart(25, "div", 17);
        i0.ɵɵelementStart(26, "label", 18);
        i0.ɵɵtext(27, "Is this a full time position?");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(28, "div", 19);
        i0.ɵɵelement(29, "p-inputSwitch", 20);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(30, JobDescriptionLcaPositionLibraryComponent_div_30_Template, 6, 2, "div", 21);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(31, "div", 22);
        i0.ɵɵelementStart(32, "h5", 23);
        i0.ɵɵtext(33, "Wage offer Information");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(34, "div", 24);
        i0.ɵɵelementStart(35, "div", 3);
        i0.ɵɵelementStart(36, "label", 25);
        i0.ɵɵtext(37, " Wage ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(38, "span", 26);
        i0.ɵɵelement(39, "i", 27);
        i0.ɵɵelement(40, "input", 28);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(41, JobDescriptionLcaPositionLibraryComponent_div_41_Template, 3, 2, "div", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(42, "div", 29);
        i0.ɵɵelementStart(43, "label", 25);
        i0.ɵɵtext(44, " Wage Unit ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(45, "p-dropdown", 30);
        i0.ɵɵlistener("onChange", function JobDescriptionLcaPositionLibraryComponent_Template_p_dropdown_onChange_45_listener($event) { return ctx.onWageUnitChange($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(46, JobDescriptionLcaPositionLibraryComponent_div_46_Template, 2, 1, "div", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(47, "div", 3);
        i0.ɵɵelementStart(48, "label", 25);
        i0.ɵɵtext(49, " Annual Compensation ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(50, "span", 26);
        i0.ɵɵelement(51, "i", 27);
        i0.ɵɵelement(52, "input", 31);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(53, "div", 14);
        i0.ɵɵelement(54, "lib-h1b-job-description", 32);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(55, "div", 22);
        i0.ɵɵelementStart(56, "h5", 33);
        i0.ɵɵtext(57, "Upload Offer Related Documents");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(58, "div", 14);
        i0.ɵɵelement(59, "file-upload-library", 34);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(60, JobDescriptionLcaPositionLibraryComponent_lib_custom_questionnaire_60_Template, 1, 6, "lib-custom-questionnaire", 35);
        i0.ɵɵelementStart(61, "div", 36);
        i0.ɵɵelement(62, "div", 37);
        i0.ɵɵelementStart(63, "div", 38);
        i0.ɵɵelement(64, "button", 39);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(65, "p-divider");
    } if (rf & 2) {
        i0.ɵɵproperty("formGroup", ctx.jobPositionDescriptionForm);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isSimplify);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("readonly", ctx.disabledControls);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.jobPositionDescriptionForm.controls["jobTitle"].touched && ctx.jobPositionDescriptionForm.controls["jobTitle"].invalid);
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("disabled", ctx.disabledControls)("showIcon", true);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.jobPositionDescriptionForm.controls["startDate"].touched && ctx.jobPositionDescriptionForm.controls["startDate"].invalid);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("disabled", ctx.disabledControls)("showIcon", true);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.jobPositionDescriptionForm.controls["endDate"].touched && ctx.jobPositionDescriptionForm.controls["endDate"].invalid);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.jobPositionDescriptionForm.controls["endDate"].errors == null ? null : ctx.jobPositionDescriptionForm.controls["endDate"].errors.positionDateValidation);
        i0.ɵɵadvance(8);
        i0.ɵɵproperty("disabled", ctx.disabledControls);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.jobPositionDescriptionForm.get("thisFulltime").value === false);
        i0.ɵɵadvance(10);
        i0.ɵɵproperty("readonly", ctx.disabledControls);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.jobPositionDescriptionForm.controls["wagesFrom"].touched && ctx.jobPositionDescriptionForm.controls["wagesFrom"].invalid);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("options", ctx.wageUnitType)("filter", false)("disabled", ctx.disabledControls);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.jobPositionDescriptionForm.controls["wageTypeCode"].touched && ctx.jobPositionDescriptionForm.controls["wageTypeCode"].invalid);
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("readonly", ctx.disabledControls);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("parentForm", ctx.jobPositionDescriptionForm)("disabledControls", ctx.disabledControls)("beneficiaryId", ctx.primaryData == null ? null : ctx.primaryData.beneficiaryId)("isWizard", ctx.isFromWizard)("petitionId", ctx.primaryData == null ? null : ctx.primaryData.petitionId);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("fileUploadConfigurations", ctx.fileUploadConfigurations);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isFromWizard);
        i0.ɵɵadvance(4);
        i0.ɵɵpropertyInterpolate("label", ctx.isFromWizard ? "Save" : "Save & Continue");
        i0.ɵɵproperty("ngClass", ctx.jobPositionDescriptionForm.invalid || ctx.disabledControls || !(ctx.jobPositionDescriptionForm.get("selectedRaiobtn").value === 0 || ctx.jobPositionDescriptionForm.get("selectedRaiobtn").value === 1 && (ctx.jobPositionDescriptionForm.get("jobRole").value && (ctx.jobPositionDescriptionForm.get("jobRole").value !== "Other" || ctx.jobPositionDescriptionForm.get("jobRole").value === "Other" && ctx.jobPositionDescriptionForm.get("otherJobPosition").value) && ctx.jobPositionDescriptionForm.get("duties").value && ctx.jobPositionDescriptionForm.get("duties").value.length > 0)) ? "btn-success button-width-icon-left mr-3 btn-success_disabled" : "btn-success button-width-icon-left mr-3")("disabled", ctx.jobPositionDescriptionForm.invalid || ctx.disabledControls || !(ctx.jobPositionDescriptionForm.get("selectedRaiobtn").value === 0 || ctx.jobPositionDescriptionForm.get("selectedRaiobtn").value === 1 && (ctx.jobPositionDescriptionForm.get("jobRole").value && (ctx.jobPositionDescriptionForm.get("jobRole").value !== "Other" || ctx.jobPositionDescriptionForm.get("jobRole").value === "Other" && ctx.jobPositionDescriptionForm.get("otherJobPosition").value) && ctx.jobPositionDescriptionForm.get("duties").value && ctx.jobPositionDescriptionForm.get("duties").value.length > 0)));
    } }, directives: [i1$1.ɵangular_packages_forms_forms_ba, i1$1.NgControlStatusGroup, i1$1.FormGroupDirective, i14.NgIf, i1$1.DefaultValueAccessor, i1$1.NgControlStatus, i1$1.FormControlName, i15.InputText, i16.Calendar, i17.InputSwitch, i18.Dropdown, i19.H1bJobDescriptionLibraryComponent, i20.FileUploadLibraryComponent, i21.ButtonDirective, i14.NgClass, i22.Divider, i1$1.PatternValidator, i23.CustomQuestionnaireComponent], styles: [".label-cls[_ngcontent-%COMP%]{color:#4a4a4a;font:normal normal normal 14px/20px Source Sans Pro}[_nghost-%COMP%]  .p-checkbox-label{margin-bottom:0}.readOnly-label[_ngcontent-%COMP%]{width:100%;font-size:16px;color:#4a4a4a;padding-top:3px;font-weight:500}.sub-title[_ngcontent-%COMP%]{color:#3d3d63;font-size:18px;font-weight:700}.mask-input[_ngcontent-%COMP%]{width:100%}.pi-dollar[_ngcontent-%COMP%]:before{font-size:13px}.mask-in[_ngcontent-%COMP%]{padding-left:22px}.btn-outline-secondary[_ngcontent-%COMP%]{border:1px solid #19a0da!important;background:#fff;height:43px;color:#19a0da;text-transform:uppercase;padding:0 17px!important;font-size:18px!important}.btn-outline-secondary.disabled[_ngcontent-%COMP%], .btn-outline-secondary[_ngcontent-%COMP%]:disabled{opacity:.65!important;border-color:#6c757d!important;color:#6c757d;background-color:transparent}.label-hint[_ngcontent-%COMP%]{margin-left:10px;font-size:14px;color:#d0c9d6}.chip-content[_ngcontent-%COMP%]{font-size:12px;color:#4d4848}.p-field-checkbox[_ngcontent-%COMP%], .p-field-radiobutton[_ngcontent-%COMP%]{margin-bottom:.5rem!important}.p-inputtext[_ngcontent-%COMP%], .processing-dropdown[_ngcontent-%COMP%]{border-color:#c3d0de!important;font-size:15px!important;color:#3f3356!important;margin-top:10px!important}.p-chips[_ngcontent-%COMP%]   .p-chips-multiple-container[_ngcontent-%COMP%]{border-color:#ced4da!important}.save-btn[_ngcontent-%COMP%]{background-color:#19a0da;padding:0 30px!important;font-size:14px!important;border-radius:8px!important}.cancel-btn[_ngcontent-%COMP%]{border-radius:10px;text-transform:uppercase;font-size:12px;font-weight:700;padding:10px}.cancel-btn[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{font-size:20px;padding:2px}.mark-btn[_ngcontent-%COMP%]{background-color:#fff;color:#a2a2a2;font-size:14px;text-transform:uppercase;border:1px solid #a2a2a2;border-radius:8px}.close-icon[_ngcontent-%COMP%]{color:#fff;background-color:#000;padding:8px;border-radius:20px;font-weight:700;cursor:pointer}.step-title[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%]{color:#3d3d63;font:normal normal 700 22px/32px Source Sans Pro}.step-title[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{color:#626262;font:normal normal normal 16px/22px Source Sans Pro}.main-body[_ngcontent-%COMP%]{height:calc(80vh - 216px);width:100%;overflow:auto}.p-radiobutton-label[_ngcontent-%COMP%]{font:normal normal normal 16px/20px Source Sans Pro!important}.save-location[_ngcontent-%COMP%]   .p-button[_ngcontent-%COMP%]{border:none!important;color:#19a0da!important;font:normal normal 600 16px/22px Source Sans Pro!important;right:30px!important}.positionTitle[_ngcontent-%COMP%]{font:normal normal 700 14px/20px Source Sans Pro!important;color:#4a4a4a!important}.bold-label[_ngcontent-%COMP%]   .label-cls[_ngcontent-%COMP%]{color:#4d4f5c!important;font:normal normal 600 16px/20px Source Sans Pro!important}.workingHr[_ngcontent-%COMP%]{font:normal normal normal 13px/18px Source Sans Pro!important;color:#4a4a4a!important}.hideView[_ngcontent-%COMP%]{visibility:hidden}.showView[_ngcontent-%COMP%]{visibility:visible}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JobDescriptionLcaPositionLibraryComponent, [{
        type: Component,
        args: [{
                selector: 'job-description-lca-position-library',
                templateUrl: 'job-description-lca-position-library.component.html',
                styleUrls: ['job-description-lca-position-library.component.scss'],
            }]
    }], function () { return [{ type: i1$1.FormBuilder }, { type: i2.Store }, { type: i3.APIJobDescription }, { type: i4.ToastrService }, { type: i5.StepStatusUpdatePayloadService }, { type: i6.DirtyFormGuard }, { type: i7.CacheCountryListService }, { type: i8.ReferenceLibraryService }, { type: i0.ChangeDetectorRef }, { type: i9.DialogService }, { type: i3.DateValidators }, { type: i10.AppServicesLibraryService }, { type: i11.ListJobDutiesService }, { type: JobDescriptionLcaPositionLibraryService }, { type: i13.APILCASOCCode }]; }, { helpVideoComponent: [{
            type: ViewChild,
            args: [HelpVideoOverlayLibraryComponent, { static: false }]
        }], isForeignCompany: [{
            type: Input
        }], primaryData: [{
            type: Input
        }], deleteAllDutie: [{
            type: Input
        }], addUpdateDuty: [{
            type: Input
        }], deleteDuty: [{
            type: Input
        }], deleteSubDuty: [{
            type: Input
        }], parentForm: [{
            type: Input
        }], isFromWizard: [{
            type: Input
        }], jobDescriptionSubmitted: [{
            type: Output
        }], jobPositionDescriptionForm: [{
            type: ViewChild,
            args: ['jobDescriptionForm', { static: true }]
        }] }); })();

class JobDescriptionLcaPositionLibraryModule {
}
JobDescriptionLcaPositionLibraryModule.ɵfac = function JobDescriptionLcaPositionLibraryModule_Factory(t) { return new (t || JobDescriptionLcaPositionLibraryModule)(); };
JobDescriptionLcaPositionLibraryModule.ɵmod = i0.ɵɵdefineNgModule({ type: JobDescriptionLcaPositionLibraryModule });
JobDescriptionLcaPositionLibraryModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            PrimengLibraryModule,
            FormsModule,
            ReactiveFormsModule,
            StepStatusUpdateComponentLibraryModule,
            JobDutiesLibraryModule,
            CustomQuestionnaireModule,
            FileUploadLibraryModule,
            H1bJobDescriptionModule,
            LastUpdateLibraryModule,
            HelpVideoOverlayLibraryModule,
            AssigningTaskLibraryModule,
            MaximizeDialogLibraryModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(JobDescriptionLcaPositionLibraryModule, { declarations: [JobDescriptionLcaPositionLibraryComponent], imports: [PrimengLibraryModule,
        FormsModule,
        ReactiveFormsModule,
        StepStatusUpdateComponentLibraryModule,
        JobDutiesLibraryModule,
        CustomQuestionnaireModule,
        FileUploadLibraryModule,
        H1bJobDescriptionModule,
        LastUpdateLibraryModule,
        HelpVideoOverlayLibraryModule,
        AssigningTaskLibraryModule,
        MaximizeDialogLibraryModule], exports: [JobDescriptionLcaPositionLibraryComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JobDescriptionLcaPositionLibraryModule, [{
        type: NgModule,
        args: [{
                declarations: [JobDescriptionLcaPositionLibraryComponent],
                imports: [
                    PrimengLibraryModule,
                    FormsModule,
                    ReactiveFormsModule,
                    StepStatusUpdateComponentLibraryModule,
                    JobDutiesLibraryModule,
                    CustomQuestionnaireModule,
                    FileUploadLibraryModule,
                    H1bJobDescriptionModule,
                    LastUpdateLibraryModule,
                    HelpVideoOverlayLibraryModule,
                    AssigningTaskLibraryModule,
                    MaximizeDialogLibraryModule
                ],
                exports: [JobDescriptionLcaPositionLibraryComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of job-description-lca-position-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { JobDescriptionLcaPositionLibraryComponent, JobDescriptionLcaPositionLibraryModule, JobDescriptionLcaPositionLibraryService, deleteDialogConfigurations };
//# sourceMappingURL=job-description-lca-position-library.js.map
